<template>
  <v-container fluid class="mx-2 my-0 px-0">
    <v-card flat v-if="show">
        <v-toolbar color="error" flat dense dark>
            <v-toolbar-title class="body-2 text-none toolbar-heading">
                {{errorsDescription}}
          </v-toolbar-title>
        </v-toolbar>
      <v-list class="list-container">
        <v-list-item v-for="error in errors" :key="error.index" class="list-tile">
            {{error.index}} - {{error.text}}
        </v-list-item>
      </v-list>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'error-panel',
  data () {
    return {
      showLoader: this.show
    }
  },
  props: {
    errors: {
      type: Array
    },
    errorsDescription: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" type="text/scss">
  .list-container {
    height: 200px;
    overflow-y: scroll;
    overflow-x:hidden;
    font-size: 11pt;
    border: 1px solid rgba(0, 0, 0, .12);
  }

  .list-tile {
    border-bottom: 1px solid rgba(0, 0, 0, .12);
  }

</style>
